const gql = {
  query: `mutation verifyResidentialAddress($input: ResidentialAddress!){
    verifyResidentialAddress(input: $input)
}`,
  variables: {
    input: {
      addressLines: null,
      city: null,
      state: null,
      stateCountryCode: null,
      zipCode: null,
      zipCodeSuffix: null,
    },
  },
  meta: {
    label: "Verify Residential Address",
  },
};

export default gql;
